<template>
  <div>
    <!-- <v-container> -->
    <v-card max-width="1200" class="container mt-16">
      <v-card-title class="d-flex align-center">
        <v-row>
          <v-col cols="11">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              icon
              :label="$t('generics.search')"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="center-all">
            <v-icon
              color="primary"
              @click="addDialog = true"
              v-text="'mdi-plus'"
            />
            <v-icon color="primary" @click="loadData" v-text="'mdi-refresh'" />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :loading="loading"
        :options.sync="options"
        :server-items-length="total"
        :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      >
        <template v-slot:item.actions="{ item }">
          <!-- {{ item }} -->
          <span v-if="item.role < 2" class="error--text">{{
            $t("generics.administration")
          }}</span>
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
            v-if="item.role >= 2"
            >mdi-pencil</v-icon
          >
          <v-icon small @click="deleteItem(item)" v-if="item.role >= 2"
            >mdi-delete</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
    <!-- </v-container> -->
    <user-handler v-if="addDialog" v-model="addDialog" :isNew="true" />
    <user-handler v-if="editDialog" v-model="editDialog" :user="current" />
  </div>
</template>

<script>
import userHandler from "@/components/handler/UserHandler.vue";
import SwalMixins from "@/mixins/swal";
import PaginationMixin from "@/mixins/pagination";
export default {
  name: "usersTable",
  components: { userHandler },
  mixins: [SwalMixins, PaginationMixin],
  data() {
    return {
      loading: false,
      headers: [
        { text: this.$t("auth.email"), value: "email" },
        { text: this.$t("auth.fullname"), value: "fullname" },
        { text: this.$t("auth.phone"), value: "phone" },
        { text: this.$t("generics.actions"), value: "actions", width: "10%" },
      ],
      current: null,
      search: "",
      searchTimeout: null,
      addDialog: false,
      editDialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["email"],
        sortDesc: [false],
      },
    };
  },
  computed: {
    users() {
      return this.$store.getters.users;
    },
    total() {
      return this.$store.getters.usersTotal;
    },
  },
  methods: {
    async loadData() {
      this.loading = true;
      await this.$store.dispatch(
        "user/index",
        this.buildPaginationParams(this.options, { search: this.search })
      );
      this.loading = false;
    },
    editItem(item) {
      this.current = item;
      this.editDialog = true;
    },
    async deleteItem(item) {
      let { isConfirmed } = await this.createSwal({
        icon: "warning",
        title: `${this.$t("generics.delete")} ${item.email}?`,
      });
      if (isConfirmed) {
        await this.$store.dispatch("user/destroy", item._id);
      }
    },
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true,
    },
    search() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.options.page !== 1) {
          this.options.page = 1;
        } else {
          this.loadData();
        }
      }, 300);
    },
  },
  async mounted() {
    this.$store.commit("title/set", this.$t(`route.${this.$route.name}`));
  },
};
</script>
